<template>
  <!-- <v-parallax id="home" dark src="../assets/images/image-8.jpg">
    <v-overlay color="white" value="true" absolute class="overlay"></v-overlay>
    <v-row
      align="center"
      justify="center"
      class="fill-height"
      style="z-index:999"
    >
      <v-col class="text-center" cols="12" sm="4">
        <div style="display: inline-block">
          <img class="logo" src="../assets/images/Foodtag.png" />
          <div class="slogan black--text mt-15">
            Good Food. Quality Food.
          </div>
        </div>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.smAndUp" />
      <v-col cols="12" sm="6" class="fill-height d-flex flex-column justify-end"
        ><div class="d-flex justify-end mb-1" style="z-index:998;">
          <a
            class="route-name black--text"
            @click="$vuetify.goTo('#why_foodtag', scrollOptions)"
            >Why Foodtag</a
          >
          <a
            class="route-name black--text"
            @click="$vuetify.goTo('#quality_mark', scrollOptions)"
            >The Quality Mark</a
          >
          <a
            class="route-name black--text"
            @click="$vuetify.goTo('#our_values', scrollOptions)"
            >Our Values</a
          >
          <a
            class="route-name black--text"
            @click="$vuetify.goTo('#contact_us', scrollOptions)"
            >Contact Us</a
          >
        </div></v-col
      >
    </v-row>
  </v-parallax> -->

  <div id="home" class="app-header">
    <!-- <v-overlay
      color="white"
      value="true"
      class="overlay fill-height"
    ></v-overlay> -->
    <v-row
      align="center"
      justify="center"
      class="fill-height"
      style="z-index:999"
    >
      <v-col class="text-center" cols="12" sm="4">
        <div style="display: inline-block">
          <img class="logo" src="../assets/images/Foodtag.png" />
          <div class="slogan black--text mt-15">
            Good Food. Quality Food.
          </div>
        </div>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.smAndUp" />
      <v-col cols="12" sm="6" class="align-self-end d-flex justify-end">
        <a
          class="route-name white--text ml-15"
          @click="$vuetify.goTo('#why_foodtag', scrollOptions)"
          >Why Foodtag</a
        >
        <a
          class="route-name white--text"
          @click="$vuetify.goTo('#quality_mark', scrollOptions)"
          >The Quality Mark</a
        >
        <a
          class="route-name white--text"
          @click="$vuetify.goTo('#our_values', scrollOptions)"
          >Our Values</a
        >
        <a
          class="route-name white--text"
          @click="$vuetify.goTo('#contact_us', scrollOptions)"
          >Contact Us</a
        ></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
